import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/modules/shared.module';
import { SubscriptionStatusBadgeComponent } from './subscription-status-badge.component';

@NgModule({
  declarations: [
    SubscriptionStatusBadgeComponent,
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    SubscriptionStatusBadgeComponent,
  ],
})
export class SubscriptionStatusBadgeModule { }
